export default __webpack_public_path__ + "static/media/nftssc.1f8f89a5.png";